'use client';

import { useEffect } from 'react';

const TAB_MARKER_KEY = 'app_tab_initialized';
const TAB_COUNT_KEY = 'app_tab_count';

const CLEAR_KEYS = [
    'provider_view_type',
    'public_providers_view_type',
    'tasks_view_type',
    'last_messages',
    'last_offer',
    'last_offer_other',
    'provider_questions',
    'provider_package',
    'coupon_code',
    'contract_code',
    'contract_name',
    'contract_city',
    'contract_address_zip',
    'contract_street',
    'users_name',
    'users_street',
    'users_city',
    'users_address_zip',
    'users_tax_number'
];

const getTabCount = () => {
    const raw = localStorage.getItem(TAB_COUNT_KEY);
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : 0;
};

const setTabCount = (value) => {
    localStorage.setItem(TAB_COUNT_KEY, String(value));
};

const clearTrackedLocalStorage = () => {
    CLEAR_KEYS.forEach((key) => localStorage.removeItem(key));
};

export default function StorageSessionGuard() {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        try {
            if (!sessionStorage.getItem(TAB_MARKER_KEY)) {
                const nextCount = getTabCount() + 1;
                setTabCount(nextCount);
                sessionStorage.setItem(TAB_MARKER_KEY, '1');
            }

            // pagehide bfcache-kompatibilis; beforeunload Firefoxon blokkolja a bfcache-t.
            // event.persisted === true: az oldal bfcache-be kerül (NEM törlünk, user visszajön)
            // event.persisted === false: valódi unload (törlünk)
            const handlePageHide = (event) => {
                if (event.persisted) return; // bfcache freeze: tab él tovább
                if (!sessionStorage.getItem(TAB_MARKER_KEY)) return;

                const nextCount = Math.max(getTabCount() - 1, 0);
                if (nextCount === 0) {
                    clearTrackedLocalStorage();
                    localStorage.removeItem(TAB_COUNT_KEY);
                } else {
                    setTabCount(nextCount);
                }
            };

            window.addEventListener('pagehide', handlePageHide);

            return () => {
                window.removeEventListener('pagehide', handlePageHide);
            };
        } catch (error) {
            // Storage may be blocked; ignore in that case.
        }
    }, []);

    return null;
}
